module.exports = "https://r.zoocdn.com/_next/static/other/site-d65fcd3db1233f186446d63ebfd0a1ea.webmanifest";